export const PROSPECT_IMPORT_FIELDS = [
  { value: '', label: '— Ne pas importer' },
  { value: 'fullName', label: 'Nom complet' },
  { value: 'email', label: 'Email' },
  { value: 'phone', label: 'Téléphone' },
  { value: 'company', label: 'Entreprise' },
  { value: 'position', label: 'Poste' },
  { value: 'mobilePhone', label: 'Tél. mobile' },
  { value: 'status', label: 'Statut' },
  { value: 'priority', label: 'Priorité' },
  { value: 'notes', label: 'Notes' },
  { value: 'address', label: 'Adresse' },
  { value: 'postalCode', label: 'Code postal' },
  { value: 'city', label: 'Ville' },
  { value: 'website', label: 'Site web' },
  { value: 'ape', label: 'Code APE' },
  { value: 'siret', label: 'SIRET' },
  { value: 'tags', label: 'Tags (séparés par virgule)' },
  { value: 'callbackAt', label: 'Date de rappel' },
];

export const PROSPECT_IMPORT_FIELD_LABELS = Object.fromEntries(
  PROSPECT_IMPORT_FIELDS.filter((f) => f.value).map((f) => [f.value, f.label]),
);
